var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("System Information Page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }